import Menu   from   "../Menu.js";
import global from "../global.js";

// import Editable    from "../Editable.js";

// const log = global.log.getLogger("f_mtac.ui.NoteArea");

let NoteArea = function() {
    //const editable = new Editable();
    const colors = [
        {name: "blue", value: "#007bcf"},
        {name: "green", value: "#09d02d"},
        {name: "yellow", value: "#f9f93d"},
        {name: "orange", value: "#ff7f00"},
        {name: "red", value: "#e60000"},
        {name: "black", value: "#000"}
    ];
    // this.color = "#007bcf";
    this.color = null;
    this.interaction = null;
    let interaction_end = () => {
        // editable.close();
    };
    this.init = () => {
        const tools = global.tools;

        Menu.create({
            name: "note_tools_area", 
            icon: "post_it", 
            //contents : ["#note_tools_save","#note_tools_color"],
            contents : ["#note_tools_color"],
            open_handler: () => {
                /*colors.forEach(color => {
                    if (color.value === this.color) {
                        tools.groups.note_colors.select(`note_color_${color.name}`);
                    }
                });*/
            },
            close_handler: () => {
                if (this.interaction !== null) {
                    this.interaction.cancel();
                }
            },
            close_timer: true
        });

        /*tools.register({
            name: "save",
            icon: "save",
            position: "#note_tools_save",
            handler: () => {
                if (this.interaction === null) {
                    return;
                }
                this.interaction.validate();
                Menu.close("note_tools_area");
            }
        });*/

        tools.register_group({
            name: "note_colors",
            target: "$none",
            enable: (_, selected) => {
                this.color = selected.data.color;
                this.interaction.validate();
                //editable.color(selected.data.color.value);
            },
            disable: () => {}
        });

        colors.forEach(color => {
            tools.register({
                group: "note_colors",
                name: `note_color_${color.name}`,
                data: {color},
                icon: "drop_black",
                position: "#note_tools_color",
                style: {color: color.value, "text-stroke": "1px #fff"}
            });
        });
    };

    /*
    const NOTE_CHAR_LIMIT = 32;
    const NOTE_LINE_LIMIT = 4;

    const soft_wrap = (s) => s.replace(/(?![^\n]{1,32}$)([^\n]{1,32})\s/g, "$1\n").split("\n");
    const hard_wrap = (s) => {
        var w = Array.from(Array(NOTE_LINE_LIMIT), () => ""), cn = 0;
        for (let l = 0; l < NOTE_LINE_LIMIT; l++) {
            for (let n = 0; n < NOTE_CHAR_LIMIT; n++) {
                let c = s.charAt(cn++);
                if (c === "\n" || c === "") {
                    break;
                }
                w[l] += c;
            }
        }
        if (s.charAt(cn) !== "") {
            return null;
        }
        return w;
    };
    const check_limits = (w) => {
        if (w.length > NOTE_LINE_LIMIT) {
            return false;
        }
        for (let l of w) {
            if (l.length > NOTE_CHAR_LIMIT) {
                return false;
            }
        }
        return true;
    };
    */
    
    this.interact = function() {
        return new Promise((resolve) => {
            this.interaction = {
                note_text: null,
                validate: () => {
                    //resolve(this.interaction.note_text);
                    resolve(this.color.value);
                    interaction_end();
                    this.interaction = null;
                    this.color = null;
                    global.tools.groups.note_colors.unselect();
                },
                cancel: () => {
                    resolve(null);
                    interaction_end();
                    this.interaction = null;
                    this.color = null;
                    global.tools.groups.note_colors.unselect();
                }
            };
            Menu.display(["note_tools_area"]);
            /*var default_text = "";
            this.interaction.note_text = [default_text];
            editable.init({
                text: "",
                validate_change: (new_text) => {
                    var wrapped;
                    if (new_text.length > NOTE_LINE_LIMIT * NOTE_CHAR_LIMIT) {
                        return false;
                    }
                    if ((new_text.match(/\n/g) || []).length > NOTE_LINE_LIMIT) {
                        return false;
                    }
                    wrapped = soft_wrap(new_text);
                    if (check_limits(wrapped)) {
                        this.interaction.note_text = wrapped;
                        return true;
                    }
                    wrapped = hard_wrap(new_text);
                    if (wrapped !== null) {
                        this.interaction.note_text = wrapped;
                        return true;
                    }
                    return false;
                }
            });*/
        });
    };

    window.addEventListener("f_mtac.init", () => {
        this.init();
    });
};

export default new NoteArea();
